import { createWebHashHistory,createRouter } from "vue-router";
// import App from '/src/App.vue'
import ArticleListing from '../components/ArticleListing.vue'

const routes = [
  {
      path: "/",
      // name: 'App',
      component: ArticleListing
  },
  // {path: '/news',},
  // {path: '/news/articles'}
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;